import { Controller } from "@hotwired/stimulus";
import consumer from "../channels/consumer";
import { Consumer, Mixin, Subscription } from "@rails/actioncable";

interface ExportInspectionRoundMessage {
  status: string;
  message?: string;
}

export default class extends Controller<HTMLElement> {
  static readonly targets = ["finishTrigger"];
  static readonly values = {
    exportInspectionRoundId: Number,
  };

  declare readonly exportInspectionRoundIdValue: number;
  declare readonly hasExportInspectionRoundIdValue: boolean;

  declare readonly hasFinishTriggerTarget: boolean;
  declare readonly finishTriggerTarget: HTMLAnchorElement;

  private _subscription?: Subscription<Consumer> & Mixin;
  private readonly _channel = "ExportInspectionRoundChannel";

  connect(): void {
    if (this.hasExportInspectionRoundIdValue) {
      this._openConnection();
    }
  }

  disconnect(): void {
    this._subscription?.unsubscribe();
  }

  private _openConnection() {
    this._subscription = consumer.subscriptions.create(
      {
        channel: this._channel,
        id: this.exportInspectionRoundIdValue,
      },
      {
        received: (data: ExportInspectionRoundMessage) => {
          if (data.status) {
            this._subscription?.unsubscribe();
            
            if (this.hasFinishTriggerTarget) {
              this.finishTriggerTarget.click();
            } else {
              window.location.reload();
            }
          }
        },
      }
    );
  }
}
